import { Component, OnInit, AfterViewChecked } from '@angular/core';
import { LoginDataService } from './services/dhukan/login-data.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit,AfterViewChecked  {
  
 
  title = 'Renomartadmin';

  islogin:boolean=false;

  constructor(private appService: LoginDataService){
    this.appService.serviceloginscreenChange.subscribe((value) => {
      this.islogin = this.appService.islogin;
    });
  }

  ngOnInit(){
   
  }

  ngAfterViewChecked(): void {

   // setTimeout(() =>  this.islogin=this.appService.islogin );
     
  }

}
